// extracted by mini-css-extract-plugin
export default {"wrapper":"calculationConstants_wrapper__Z7T8q","dropdownWrapper":"calculationConstants_dropdownWrapper__ydc5C"};